module Meevo.Plugins.ProfileSettings {
    "use strict";

    /**
    * Services Section of ProfileSettings 
    */
    export class ServicesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ProfileSettings> {

        COLOR_STANDARD: string = "white";
        COLOR_REVERT: string = "#E4E410";

        private numberOfPriceLevelsToDisplay;

        showPriceLevel(index): boolean {
            let show = index < this.numberOfPriceLevelsToDisplay;
            return show;
        }

        get minuteSelection(): any {
            return _.range(0, 735, 15);
        }

        toggleCanPerform(item: any): boolean {
            if (!item.doesNotPerform) {
                item.expandItem = true;
                // Initialize price level selection
                if (Model.Guard.isNothing(item.priceLevel)) {
                    const priceLevel: any = _.first(item.priceLevelSelection);
                    item.priceLevel = priceLevel.id;
                    item.price = priceLevel.price;
                };
                return true;
            }
            else {
                item.expandItem = false;
                return false;
            }
        }

        toggleExpandItem(item: any): void {
            item.expandItem = !item.expandItem
            console.log('should expand 1', item.expandItem)
        }

        toggledAllItems(items: any, value?: boolean): void {
            _.map(items, (i: any) => {
                i.expandItem = value;
            })
            console.log('should expand all as', items, value)

        }

        updateNewPrice(priceLevel: any, priceLevelSelection: any, item): void {
            let newValue: any = _.findWhere(priceLevelSelection, { id: priceLevel }) // find in array where the new price level from select matches level selections
            if (newValue) {
                item.price = newValue.price;
                item.priceRevertTo = newValue.price;
            }
        }

        updatePriceRevertTo(item: any): void {
            this.updateNewPrice(item.priceLevel, item.priceLevelSelection, item);
            item.isPriceOverriden = false;
        }

        getPriceBackgroundColor(item: any): any {
            return this.showPriceRevertTo(item) ? this.COLOR_REVERT : this.COLOR_STANDARD;
        }

        showPriceRevertTo(item: any): boolean {
            if ((item.priceRevertTo && item.price != item.priceRevertTo) || item.isPriceOverriden) {
                item.isPriceOverriden = true;
                return true;
            }
            return false;
        }

        updateMinutesRevertTo(step: any): void {
            step.minutes = step.minutesRevertTo;
            step.isMinutesOverriden = false;
        }

        showStepRevertTo(step: any): boolean {
            if (step.minutes != step.minutesRevertTo || step.isMinutesOverriden) {
                step.isMinutesOverriden = true;
                return true;
            }
            return false;
        }

        toggleEditServiceSteps(isEditing: boolean, item: any): void {
            if (!isEditing) return;
            item.isEditable = true;
        }

        onBlurOfPrice(item: any): any {
            if (!item.isPriceOverriden && item.price != item.priceRevertTo) {
                item.isPriceOverriden = true;
            }
            console.log("Price changed : " + item);
        }
    }
}